module.exports = __webpack_public_path__ + "static/media/zhihu.87c020b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/zhihu.png
// module id = 223
// module chunks = 0